import { fetchAgg } from '@atlassian/search-client';

type ZeroQueriesParams = {
	cloudId: string;
};

export type ZeroQuery = {
	query: string;
	type: 'WHO_IS' | 'RECENT_WORK' | 'RELATED_QUESTION';
};

type ZeroQueriesData = {
	knowledgeDiscovery?: {
		zeroQueries: {
			zeroQueries: ZeroQuery[];
		};
	};
};

export const fetchZeroQueries = async (variables: ZeroQueriesParams) => {
	return fetchAgg<ZeroQueriesParams, ZeroQueriesData>({
		graphQuery: ZeroQueriesQuery,
		variables,
		operationName: ZERO_QUERIES_OPERATION_NAME,
	})
		.then((response) => {
			const zeroQueries = response.data?.knowledgeDiscovery?.zeroQueries.zeroQueries || [];
			return zeroQueries.map(mapEssentialData);
		})
		.catch(() => {
			return [];
		});
};

export const mapEssentialData = (zeroQuery: ZeroQuery) => ({
	id: zeroQuery.query,
	title: zeroQuery.query,
	data: zeroQuery.query,
	type: 'zero-query' as const,
	zeroQueryType: zeroQuery.type,
});

export const ZERO_QUERIES_OPERATION_NAME = 'KnowledgeDiscoveryZeroQueries';

export const ZeroQueriesQuery = `
	query ${ZERO_QUERIES_OPERATION_NAME}($cloudId: String!) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Get Zero Queries") {
			zeroQueries(cloudId: $cloudId) {
                __typename
                ... on KnowledgeDiscoveryZeroQueries {        
                    zeroQueries {
                        query
                        type
					}
                }
            }
		}
	}
`;

type MutateZeroQueriesParams = {
	input: {
		cloudId: string;
		query: string;
	};
};

type MutateZeroQueriesResponse = {
	knowledgeDiscovery: {
		markZeroQueryInteracted: {
			success: boolean;
			errors: {
				message: string;
				extensions: {
					errorType: string;
					statusCode: number;
				};
			}[];
		};
	};
};

export const mutateZeroQueries = async (variables: MutateZeroQueriesParams) => {
	return fetchAgg<MutateZeroQueriesParams, MutateZeroQueriesResponse>({
		graphQuery: ZeroQueriesMutation,
		variables,
		operationName: MUTATE_ZERO_QUERIES_OPERATION_NAME,
	})
		.then((response) => {
			return response.data?.knowledgeDiscovery.markZeroQueryInteracted.success;
		})
		.catch((error) => {
			return error;
		});
};

export const MUTATE_ZERO_QUERIES_OPERATION_NAME = 'MarkZeroQueryInteracted';

export const ZeroQueriesMutation = `
	mutation ${MUTATE_ZERO_QUERIES_OPERATION_NAME}($input: KnowledgeDiscoveryMarkZeroQueryInteractedInput!) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Mark Zero Query Interacted") {
			markZeroQueryInteracted(input: $input) {
				success
				errors {
					message
					extensions {
						errorType
						statusCode
					}
				}
			}
		}
	}
`;
